export type InvoicesView = 'to-invoice' | 'all'

const VALID_VIEWS: readonly InvoicesView[] = ['to-invoice', 'all']

/** Parses the ?view= query param; unknown or absent values mean "auto". */
export function parseInvoicesView(param: string | null): InvoicesView | null {
  return VALID_VIEWS.includes(param as InvoicesView) ? (param as InvoicesView) : null
}

/**
 * Landing view when the URL carries no explicit ?view=: pending work wins,
 * otherwise the ledger. When the worklist failed to load we cannot know, so
 * the ledger is shown (the tab itself carries the error).
 */
export function defaultInvoicesView(activeTaskCount: number, tasksFailed: boolean): InvoicesView {
  if (tasksFailed) return 'all'
  return activeTaskCount > 0 ? 'to-invoice' : 'all'
}

export type TodoPillSeverity = 'overdue' | 'due'

/**
 * Severity of the count pill on the "À facturer" tab trigger. Mirrors the
 * planning Suivi convention: red when something is overdue, amber when work
 * is merely due, no pill when the worklist is empty.
 */
export function todoPillSeverity(activeCount: number, overdueCount: number): TodoPillSeverity | null {
  if (activeCount <= 0) return null
  return overdueCount > 0 ? 'overdue' : 'due'
}
